import { lazy, type ComponentType } from "react";
import { isChunkLoadError, reloadForChunk } from "./chunkReload.js";

/** React.lazy for a page, which reloads once to the newest build when the
 *  page's code is gone because WOV was redeployed while it was open
 *  (lib/chunkReload.ts). Any other failure reaches the error screen. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyPage<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(() =>
    factory().catch((err: unknown) => {
      if (isChunkLoadError(err) && reloadForChunk()) return new Promise<{ default: T }>(() => undefined);
      throw err;
    }),
  );
}
